var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CloActivityBadge',{attrs:{"badges":_vm.badges,"title":_vm.comName,"reverse":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }